/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    SET_FETCH_PRICING_VIEW_STATUS,
    FETCH_PRICING_VIEW_SUCCESS,
    FETCH_PRICING_VIEW_ERROR,
} from '../actions/pricingViewActions';

export const initialState = {
    loadingStatus: STATUS.IDLE,
    isLoading: true,
    error: null,
    pricesByCategory: {},
};

export const pricingViewReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_PRICING_VIEW_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_PRICING_VIEW_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        }
        case FETCH_PRICING_VIEW_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        default:
            return state;
    }
};
